import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserActionsComponent } from 'src/app/components/user-actions/user-actions.component';
import { HttpService } from 'src/app/services/http.service';
import { UiServices } from 'src/app/services/ui-services';

@Component({
  selector: 'app-users-admin',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss'],
})
export class UsersComponent implements OnInit {
  public rows: any[] = [];
  public columns = undefined;
  public page: any = 1;
  public search: string = '';
  public isActive = undefined;
  public isLoading = true;
  public rolId: string = '';
  public rols: any[] = [];
  public totalPages: any = '';
  public messages = {
    emptyMessage: 'No hay registros.',
  };

  private _id = this._route.snapshot.queryParamMap.get('id');

  constructor(
    private httpSv: HttpService,
    private uiSv: UiServices,
    private _route: ActivatedRoute
  ) {}

  async ngOnInit() {
    try {
      const resRol: any = await this.httpSv.itemIndex('admin/user/rolAll');
      const rolData = resRol.data;
      for (const key of Object.keys(rolData)) {
        const obj = {
          id: rolData[key],
          value: key,
        };
        this.rols.push(obj);
      }
      await this.getSearch();
      const column = [
        { name: 'Nombre', prop: 'name' },
        { name: 'Correo', prop: 'email' },
        { name: 'Telefono', prop: 'phoneNumber' },
        { name: 'Cedula', prop: 'dni' },
        { name: 'Pais', prop: 'country' },
        { name: 'Balance', prop: 'balance' },
        { name: 'Acciones', prop: 'showMore' },
      ];

      this.columns = column;
      if (this._id) {
        this.getUser(this._id, 'Acciones');
      }
    } catch (err) {
      console.error(err);
    }
  }

  async getSearch(ev?) {
    try {
      this.search = ev?.value || '';
      if (ev?.id) {
        this.rolId = ev?.id;
      }
      this.isLoading = true;
      const res: any = await this.httpSv.itemIndex(
        'admin/user',
        `${this.page}/${this.rolId}/${this.search}`
      );
      this.totalPages = res.data.meta.last_page;
      const userData: any[] = res.data.data;
      userData.map((item) => {
        // item.isActive = item.isActive ? 'Activo' : 'Inactivo';
        // item.isVerify = item.isVerify ? 'Verificado' : 'No verificado';
        // item.rolId = this.rols.find(rol => rol.id === item.rolId)?.value;
        // item.recharge = 'Acción';
        item.showMore = 'Ver más';
      });
      this.rows = userData;
      this.isLoading = false;
      return true;
    } catch (err) {
      console.error(err);
    }
  }

  async getClick(ev) {
    if (ev.type === 'click') {
      const columnName = ev.column.name;
      const id = ev.row.id;
      this.getUser(id, columnName);
    }
  }

  async getUser(id, columnName) {
    const params = {
      userId: id,
    };
    await this.uiSv.showLoading();
    const res: any = await this.httpSv.itemIndex(
      'admin/user',
      '',
      params,
      'show'
    );
    await this.uiSv.loading.dismiss();
    const user = res.data;
    if (columnName === 'Acciones') {
      const res = await this.uiSv.showModal(
        UserActionsComponent,
        {
          user,
          rols: this.rols,
        },
        'user-components'
      );
      if (!res.data) {
        return;
      }
      await this.getSearch();
    } else {
      return false;
    }
  }

  getRowClass(row) {
    setTimeout(() => {
      const elementsVer = document.querySelectorAll(`[title="Ver más"]`);
      elementsVer.forEach((node) => {
        node.classList.add('rolSpan');
      });
      // const elements = document.querySelectorAll(`[title="${row.rolId}"]`);
      // const elementsNoVer = document.querySelectorAll(`[title="No verificado"]`);
      // const elementsRecharge = document.querySelectorAll(`[title="Acción"]`);
      // elements.forEach(node => {
      //   node.classList.add('rolSpan');
      // });
      // elementsNoVer.forEach(node => {
      //   node.classList.add('rolSpan');
      // });
      // elementsRecharge.forEach(node => {
      //   node.classList.add('rolSpan');
      // });
    });
    return;
  }

  changePage(event) {
    this.page = event;
    this.getSearch();
  }
}
